module.exports = __webpack_public_path__ + "assets/addonivc.34bc80c6.svg";